var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"oss_file"},[_c('input',{attrs:{"type":"file","id":_vm.id,"multiple":_vm.multiple,"len":_vm.len,"accept":"image/"},on:{"change":_vm.doUpload}})])])}
var staticRenderFns = []

export { render, staticRenderFns }